export default "__VITE_ASSET__BFDTbKBR__"